import { useSelector } from 'react-redux'
import { userSelector } from 'ducks/user'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'

const usePrivateRoute = () => {
  const user = useSelector(userSelector)
  const history = useHistory()

  useEffect(() => {
    if (!user.token) {
      history.push('/')
    }
    // eslint-disable-next-line
  }, [user.token])
  return user
}

export default usePrivateRoute
